export var ButtonMode;
(function (ButtonMode) {
    ButtonMode["Primary"] = "primary";
    ButtonMode["Secondary"] = "secondary";
    ButtonMode["Tertiary"] = "tertiary";
    ButtonMode["Link"] = "link";
    ButtonMode["Danger"] = "danger";
    ButtonMode["Positive"] = "positive";
    ButtonMode["Negative"] = "negative";
})(ButtonMode || (ButtonMode = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["Button"] = "button";
    ButtonType["Reset"] = "reset";
    ButtonType["Submit"] = "submit";
})(ButtonType || (ButtonType = {}));
export var ButtonSlot;
(function (ButtonSlot) {
    ButtonSlot["IconOnly"] = "icon-only";
    ButtonSlot["Prepend"] = "prepend";
    ButtonSlot["Append"] = "append";
})(ButtonSlot || (ButtonSlot = {}));
export var ButtonTagType;
(function (ButtonTagType) {
    ButtonTagType["Button"] = "button";
    ButtonTagType["Link"] = "a";
})(ButtonTagType || (ButtonTagType = {}));
export var ButtonCssClass;
(function (ButtonCssClass) {
    ButtonCssClass["Base"] = "iress-button";
    ButtonCssClass["Fluid"] = "iress-button--fluid";
    ButtonCssClass["Button"] = "iress-button__button";
    ButtonCssClass["Inner"] = "iress-button__inner";
    ButtonCssClass["HasCustomRouting"] = "iress-button--custom-route";
    ButtonCssClass["NoWrap"] = "iress-button--no-wrap";
    ButtonCssClass["Checked"] = "iress-button--checked";
})(ButtonCssClass || (ButtonCssClass = {}));
//# sourceMappingURL=button.types.js.map